import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Input } from 'reactstrap';

import { useTrans } from '../Hooks/UserHooks';

import { addSearchValToStore } from '../../Store/commonStore/actions';
import { removeAPIDataAction } from '../../Store/callAPI/actions';
import { AuditorRoleID, CaseManagerRoleID, SAMRoleID } from '../constants/constants';
import { useSelector } from 'react-redux';
import { SelectSearchValInStore } from '../../Store/commonStore/selectors';
import { toast } from 'react-toastify';

const SearchOption = ({ small }) => {
    const t = useTrans('translation');
    const [value, setValue] = useState('');
    const location = useLocation();
    const history = useHistory();

    const searchHandler = (e) => {
        e.preventDefault();
        if (location.pathname !== '/content' && value) history.push('/content');
        addSearchValToStore(value?.trim());
        setValue((ev) => ev?.trim());
    };

    const onChangeData = (val) => {
        if (val.length > 50) {
            toast.error('Search value should not be more than 50 characters');
            return;
        }
        setValue(val);

        if (!val) {
            removeAPIDataAction('ReferralsAPI');
            addSearchValToStore(val);
        }
    };

    useEffect(() => {
        var searchOptions = document.getElementById('search-close-options');
        var searchInput = document.getElementById('search-options');

        searchInput.addEventListener('focus', function () {
            var inputLength = searchInput.value.length;
            if (inputLength > 0) {
                searchOptions.classList.remove('d-none');
            } else {
                searchOptions.classList.add('d-none');
            }
        });

        searchInput.addEventListener('keyup', function () {
            var inputLength = searchInput.value.length;
            if (inputLength > 0) {
                searchOptions.classList.remove('d-none');
            } else {
                searchOptions.classList.add('d-none');
            }
        });

        searchOptions.addEventListener('click', function () {
            onChangeData('');
            searchOptions.classList.add('d-none');
        });

        document.body.addEventListener('click', function (e) {
            if (e.target.getAttribute('id') !== 'search-options') {
                searchOptions.classList.add('d-none');
            }
        });
        if (performance?.getEntriesByType('navigation')?.length > 0 && performance.getEntriesByType('navigation')[0].type === 'reload') {
            onChangeData('');
        }
    }, []);

    return (
        <React.Fragment>
            <form onSubmit={searchHandler}>
                <div className={`app-search ${!small && 'd-none d-md-block'}`}>
                    <div className="position-relative">
                        <Input
                            type="text"
                            className={`form-control ${small ? 'w-98' : 'w-105'}`}
                            title={t('search')}
                            placeholder={t('search')}
                            id="search-options"
                            value={value}
                            onChange={(e) => {
                                onChangeData(e.target.value);
                            }}
                        />
                        <button type="submit" className="search-widget-icon d-flex">
                            <span className="ri-search-line  cursor-pointer" />
                        </button>
                        <span
                            className="ri-close-circle-line search-widget-icon search-widget-icon-close d-none"
                            id="search-close-options"
                        ></span>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );
};

export default SearchOption;
